import { Socket } from '~/modules/SDK/socket2/Socket'

export const symbolStringPrune = (symbol: Socket.SymbolString | string) => {
  if (!symbol) {
    throw new Error(`${symbolStringPrune.name}: Symbol 不見了！ :${typeof symbol}=${symbol}`)
  }

  return symbol.replace(/[\s\S]+:/, '') as Socket.SymbolString
}
